import { FC, BaseSyntheticEvent } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Control, FieldErrors } from "react-hook-form";

import LocationForm from "../../../pages/customer-settings/tabs/locations/components/LocationForm";
import { ILocationForm } from "../../../pages/customer-settings/tabs/locations/variables/locationData";
import StyledLoadingButton from "../../providers/theme/design-tokens/LoadingButton/StyledLoadingButton";
import StyledDialog from "../dialog/StyledDialog";

interface CreateLocationDialogProps {
  open: boolean;
  onClose: () => void;
  handleSubmit: (event?: BaseSyntheticEvent) => Promise<void>;
  control: Control<ILocationForm>;
  errors: FieldErrors<ILocationForm>;
  loading: boolean;
}

const CreateLocationDialog: FC<CreateLocationDialogProps> = ({
  open,
  onClose,
  handleSubmit,
  control,
  errors,
  loading,
}): JSX.Element => {
  return (
    <StyledDialog
      open={open}
      title="Add new location"
      onClose={onClose}
      showSubmitButton={false}
    >
      <form onSubmit={handleSubmit}>
        <LocationForm fullWidthInput control={control} errors={errors} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "2em",
            gap: "1em",
          }}
        >
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <StyledLoadingButton
            loading={loading}
            loadingPosition="start"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Add new location
          </StyledLoadingButton>
        </Box>
      </form>
    </StyledDialog>
  );
};

export default CreateLocationDialog;
